/**
 * Shared between the runtime `Loader` component and the build-time
 * `prerenderHero` Vite plugin (`vite.config.ts`) — both must agree on the
 * session flag, or a repeat-visit reload would show the prerendered curtain
 * flash before React mounts and instantly hides it (the loader never runs
 * twice in one session; the static markup has no way to know that on its
 * own, so the plugin injects a synchronous inline script that reads this
 * same key before first paint).
 */
export const LOADER_SESSION_KEY = 'prism.loader.seen';
